import config from '../../config/app';
import {
  setAPIHost,
  setIdentityHeader,
  setLocaleHeader,
  unsetIdentityHeader,
  setParamsSerializer
} from './configurator';

import * as auth from './auth';
import * as accounts from './accounts';
import * as reports from './reports';
import * as campaigns from './campaigns';
import * as socialAccounts from './socialAccounts';
import * as users from './users';
import * as brands from './brands';
import * as shared from './shared';
import * as chats from './chats';
import * as organizations from './organizations';
import * as teams from './teams';
import * as publications from './publications';
import * as places from './places';
import * as videos from './videos';
import * as takeRates from './takeRates';

setAPIHost(config.getAPIHost());
setParamsSerializer();

export {
  auth,
  accounts,
  reports,
  campaigns,
  socialAccounts,
  users,
  brands,
  shared,
  chats,
  setIdentityHeader,
  unsetIdentityHeader,
  setLocaleHeader,
  organizations,
  teams,
  publications,
  places,
  videos,
  takeRates
};
